export default __webpack_public_path__ + "static/media/kalahasti temple.6fdcbad8.jpg";